export default {
    ricohBanner: 'MakeLeaps Corporation is a\nmember of the RICOH Group',
};
